export default __webpack_public_path__ + "static/media/HospitalManagementSystem.3319f304.png";